module.exports = __webpack_public_path__ + "img/video-placeholder.192751e3.jpg";